export default __webpack_public_path__ + "static/media/15.27671a26.jpg";